<template>
  <div class="main">
    <report-top>
      <ly-search
        slot="search"
        v-model="searchItem.keyword"
        @search="search"
      ></ly-search
    ></report-top>
    <div id="formTable">
      <div class="formTableItem">
        <p class="label">时间范围</p>
        <start-end ref="startEnd" timeModel="2,3,0"></start-end>
      </div>
      <div class="formTableItem">
        <Button @click="chaxun" type="primary" class="chaxun"
          >查询</Button
        >
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="openDoc(row)">表单</Button>
        <Button size="small" @click="openJincheng(row)">进程</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <jincheng ref="jincheng"></jincheng>

    <Modal footer-hide width="1000" footerHide v-model="openForm"
      title="表单详情">
      <div>
        <dataDetail ref="dataDetail">
          <ul slot="passengers">
            <li v-for="(x, index) in passengers" :key="index">
              {{ x.name }}/{{ x.tel }}
            </li>
          </ul>
          <table style="width: 100%;" slot="endcontent">
            <thead>
              <tr>
                <td>签字员</td>
                <td>签字时间</td>
                <td>图片</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(t, index) in signList" :key="index">
                <td>{{ t.name }}</td>
                <td>{{ utils.time(t.time, 'yymmdd') }}</td>
                <td>
                  <imgList :data="t.fileList"></imgList>
                </td>
              </tr>
            </tbody>
          </table>
        </dataDetail>
      </div>
    </Modal>
  </div>
</template>
<script>
import axios from "axios";
import jincheng from "./jincheng.vue";
import fields from "./forms/fields";
export default {
  components: { jincheng },
  data() {
    return {
      openForm: false,
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "标题名称",
          key: "title",
        },
        {
          title: "流程名称",
          key: "flowName",
        },
        {
          title: "当前节点",
          key: "nodeName",
        },
        {
          title: "流转人",
          key: "perUser",
        },
        {
          title: "处理人",
          key: "addUser",
        },
        {
          title: "状态标签",
          key: "stateLable",
        },
        {
          title: "后续处理人",
          key: "auditorUser",
        },
        {
          title: "操作",
          slot: "action",
          width: 130,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        name: "",
        icon: "car",
        remark: "",
        category: "其他类",
      },
      ruleValidate: {
        name: { required: true, message: "必填" },
        icon: { required: true, message: "必填" },
      },

      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
        startDate:0,
        endDate:0
      },
      total: 0,
      categorys: [],
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.flow + "/flow/historyList",
        data: this.searchItem,
      }).then((res) => {
        console.log(res);
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        this.tableData = data;
      });
    },

    //点击编辑按钮
    openJincheng(row) {
      this.$refs.jincheng.reach(row);
    },
    openDoc(row) {
      this.openForm = true;
      this.item=row;
      this.getDetail(row);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    chaxun() {
      this.searchItem.startDate = this.$refs.startEnd.getTimeObj().start;
      this.searchItem.endDate = this.$refs.startEnd.getTimeObj().end;
      this.getList();
    },
    //获取详情
    getDetail() {
      console.log(fields[this.item.formId + 1]);
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + fields[this.item.formId + 1],
        data: { id: this.item.docId }
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data;
        this.detailChuli(data);
      });
    },
    //对详情进行处理
    detailChuli(data) {
      console.log(333, data);
      if (this.item.formId == 'yongcheshenqing') {
        this.passengers = data.passengers;
        data.planStartTime22 = this.utils.time(data.planStartTime);
        data.planEndTime2 = this.utils.time(data.planEndTime);
        // this.passengers=[{name:111111,tel:33333333}];
      }
      if (this.item.formId == 'baoyang') {
        data.careDate2 = this.utils.time(data.careDate, "yymmdd");
      }
      if (this.item.formId == 'baoxian') {
        data.insurDate2 = this.utils.time(data.insurDate, "yymmdd");
        data.expireDate2 = this.utils.time(data.expireDate, "yymmdd");
      }
      if (this.item.formId == 'jiayou') {
        data.refuelDate2 = this.utils.time(data.refuelDate, "yymmdd");
      }
      if (this.item.formId == 'weixiu') {
        data.repairDate2 = this.utils.time(data.repairDate, 'yymmdd');
      }
      if (this.item.formId == 'weizhang') {
        data.peccancyDate2 = this.utils.time(data.peccancyDate2, "yymmdd");
      }
      this.signList = data.signList;
      //console.log('huoquxiangqing', data)
      this.$refs.dataDetail.reach(data, [{ title: '工单号', key: 'no' }, ...fields[this.item.formId]]);
    },
  },
  mounted() {
    this.chaxun();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/diaodu/yibanchuli.vue